export const BOTTOM_SERIES_POINT_CATEGORY_KEY = 'charting' as const;
export const BOTTOM_SERIES_POINT_PARENT_COMPONENT_KEY = 'blockRangeChart' as const;
export const BOTTOM_SERIES_POINT_COMPONENT_KEY = 'bottomSeriesPoint' as const;
